import { makeStubAdapter } from './_stub';
export const crazygamesAdapter = makeStubAdapter('crazygames');
